import {
  DocumentReference,
  QueryDocumentSnapshot,
  QuerySnapshot,
  CollectionReference,
  query,
  where,
  getDocs,
  orderBy,
  collection,
  addDoc,
  updateDoc,
  getFirestore,
} from 'firebase/firestore';
import {
  getBoardId,
  getBoardViewId,
  getTenantId,
  getUserId,
} from './firebaseInit';
import { getDefaultConverter } from '../utils/helpers/firestore';
import { Template } from '../@types/domain';

function transformDocumentAsTemplate(
  document_: QueryDocumentSnapshot<Template>
): Template {
  return document_.data();
}

function transformDocumentsAsTemplates(
  snapshot: QuerySnapshot<Template>
): Template[] {
  return snapshot.docs.map((document) => transformDocumentAsTemplate(document));
}

function getTemplatesCollection(): CollectionReference {
  return collection(getFirestore(), 'templates');
}

/**
 * Get all my active templates
 */
export async function getMyActiveTemplates(): Promise<Template[]> {
  const tenantId = String(getTenantId());
  const boardId = String(getBoardId());
  const boardViewId = getBoardViewId();

  const q = query(
    getTemplatesCollection(),
    where('tenantId', '==', tenantId),
    where('boardId', '==', boardId),
    where('boardViewId', '==', boardViewId),
    where('deleted', '==', false),
    orderBy('name')
  ).withConverter(getDefaultConverter<Template>());

  const querySnapshot = await getDocs(q);
  return transformDocumentsAsTemplates(querySnapshot);
}

export async function addTemplate(name: string): Promise<Template | undefined> {
  const template: Omit<Template, 'id' | 'ref'> = {
    tenantId: String(getTenantId()),
    boardId: String(getBoardId()),
    boardViewId: getBoardViewId(),
    createdBy: getUserId(),
    deleted: false,
    columns: [],
    name,
  };

  const documentReference = await addDoc(
    getTemplatesCollection(),
    template as Template
  );
  return { id: documentReference.id, ref: documentReference, ...template };
}

export async function deleteTemplate(
  templateReference: DocumentReference
): Promise<void> {
  await updateDoc(templateReference, {
    deleted: true,
    deletedBy: getUserId(),
  });
}

export async function updateTemplate(
  templateReference: DocumentReference,
  data: Omit<Template, 'id' | 'ref' | 'createdBy' | 'deleted'>
): Promise<void> {
  await updateDoc(templateReference, data);
}
